import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {ProduktDTO} from '../../openapi/fakturierung-openapi';


export const produktEntitiesAdapter: EntityAdapter<ProduktDTO> = createEntityAdapter<ProduktDTO>();
